const ZERO_ADDRESS: string = '0x0000000000000000000000000000000000000000';

export { ZERO_ADDRESS };
